import type { Api } from "@reduxjs/toolkit/query";
import { locationsApiSlice } from "../api/locations/locationsApiSlice";
import {
  availabilitiesApiSlice,
  supAvailabilitiesApiSlice,
} from "../api/availabilities/availabilitiesApiSlice";
import { reservationsApiSlice } from "../api/reservations/reservationsApiSlice";
import { paymentsApiSlice } from "../api/payments/paymentsApiSlice";
import { bookingsApiSlice } from "../api/bookings/bookingsApiSlice";
import { hintsApiSlice } from "../api/hints/hintsApiSlice";
import { rentalsApiSlice } from "../api/rentals/rentalsApiSlice";
import { lockersApiSlice } from "../api/lockers/lockersApiSlice";
import { issueReportApiSlice } from "../api/issueReport/issueReportApiSlice";
import { receiverApiSlice } from "../api/receiver/receiverApiSlice";
import { apartmentBookingApiSlice } from "../api/apartment/apartmentApiSlice";
import { vouchersApiSlice } from "../api/voucher/voucherApiSlice";
import { infoApiSlice } from "../api/info/infoApiSlice";
import { commercialModelsApiSlice } from "../api/commercialModels/commercialModelsApiSlice";
import { customerAgreementsApiSlice } from "../api/customerAgreements/customerAgreementsApiSlice";
import { usageLogApiSlice } from "../api/usageLog/usageLogApiSlice";
import { accountApiSlice } from "../api/account/accountApiSlice";
import { ideaSubmissionApiSlice } from "../api/ideaSubmission/ideaSubmissionApiSlice";
import { pricePreviewApiSlice } from "../api/pricePreview/pricePreviewApiSlice";
import { roomWeekApiSlice } from "../api/roomWeek/roomWeekApiSlice";
import { categoryRoomsApiSlice } from "../api/categoryRooms/categoryRoomsApiSlice";

/**
 * Every RTK Query slice in the app, in one list.
 *
 * The list is what wires each slice's middleware in `store.ts` — so a slice
 * missing from it does not work at all, which is noticed immediately. That
 * property is deliberate: it makes the same list safe to reuse wherever
 * something must hold for *all* slices (currently the account-scoped cache
 * eviction in `accountScopedCaches.ts`), instead of maintaining a second list
 * by hand that silently falls behind. Same reasoning as admin-ui's
 * `API_SLICES` (`docs/architecture/tenant-scoped-caching.md`).
 *
 * Adding a slice: add it here, add its reducer in `store.ts`, and classify it
 * in `accountScopedCaches.ts` — a unit test fails until you do.
 */
export const API_SLICES = [
  locationsApiSlice,
  availabilitiesApiSlice,
  supAvailabilitiesApiSlice,
  reservationsApiSlice,
  bookingsApiSlice,
  paymentsApiSlice,
  hintsApiSlice,
  rentalsApiSlice,
  lockersApiSlice,
  issueReportApiSlice,
  receiverApiSlice,
  apartmentBookingApiSlice,
  vouchersApiSlice,
  infoApiSlice,
  commercialModelsApiSlice,
  customerAgreementsApiSlice,
  usageLogApiSlice,
  accountApiSlice,
  ideaSubmissionApiSlice,
  pricePreviewApiSlice,
  roomWeekApiSlice,
  categoryRoomsApiSlice,
] as const satisfies readonly Api<any, Record<string, any>, string, string, any>[];

export default API_SLICES;
